// The ✨ Wizard button in the transport: a glowing, gently shimmering way to the Wizard panel below
// the grid (it scrolls there and lights the panel up for a moment). Still when the OS asks for
// reduced motion.
import { prefersCalm } from "../ui/settings";

export function WizardButton() {
  const go = () => {
    const panel = document.getElementById("wizard");
    if (!panel) return;
    panel.scrollIntoView({ behavior: prefersCalm() ? "auto" : "smooth", block: "start" });
    panel.classList.remove("wizard-arrived");
    // Restart the arrival glow (reflow between remove and add).
    void panel.offsetWidth;
    panel.classList.add("wizard-arrived");
    panel.querySelector<HTMLElement>("select, button, a")?.focus({ preventScroll: true });
  };
  return (
    <button
      type="button"
      className="wizard-magic"
      onClick={go}
      title="The Wizard writes chords, bass, melodies, arpeggios, fills and grooves with you — in today's key and sounds"
      data-testid="wizard-jump"
    >
      <span className="wizard-sparkles" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
        <i />
        <i />
      </span>
      <span className="wizard-star" aria-hidden="true">
        ✨
      </span>
      <span className="wizard-label">
        Wizard
        <span className="wizard-sub">writes with you</span>
      </span>
    </button>
  );
}
